"use strict";

exports.__esModule = true;
exports.joinClassNames = void 0;
exports.joinClassNames = function () {
  var classNames = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    classNames[_i] = arguments[_i];
  }
  return classNames.filter(function (c) {
    return c;
  }).join(' ');
};